export default {"src":"https://static.eleduck.com/_next/static/media/female.f9c5d751.svg","height":25,"width":13,"blurWidth":0,"blurHeight":0};